<template>
  <ion-page>
    <ion-content :fullscreen="true">
      <div class="px-3 flex items-center justify-center">
        <ion-grid>
          <ion-row>
            <ion-col>
              <div v-html="content"></div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import { IonCol, IonContent, IonGrid, IonPage, IonRow } from "@ionic/vue";
import { useConnectionStore } from "@/modules/connection/store/connection";
import { useDirectusStore } from "@/modules/directus/store/directus";
import { isPlatform, type Platforms, useIonRouter } from "@ionic/vue";
import { onMounted, ref } from "vue";
import { App } from "@capacitor/app";
import { readItems } from "@directus/sdk";
import { compareVersions } from "compare-versions";

const loading = ref(true);
const error = ref(false);
const content = ref("");
const ionRouter = useIonRouter();
const directus = useDirectusStore();

onMounted(async () => {
  const platforms: Platforms[] = ["ios", "android"];
  const platform = platforms.find((availablePlatform) =>
    isPlatform(availablePlatform)
  );
  if (platform) {
    try {
      const appVersion = (await App.getInfo()).version;
      const release = (await directus.main.request(readItems("releases"))).find(
        (release) => release.platform === platform
      );
      if (
        release &&
        release.version &&
        compareVersions(release.version, appVersion) === 1
      ) {
        content.value = release.description;
      }
    } catch (_error) {
      if (useConnectionStore().connectionStatus?.connected) {
        error.value = true;
        return;
      }
    }
  }
  loading.value = false;

  ionRouter.push({
    name: "cities",
  });
});
</script>

<style scoped></style>
